import React from 'react';
import { useState, useEffect } from 'react';

import Tl from '../../../localization/LocalizationKeys';
import ModelType from '../../Model/ModelType';
import EditItemModal from '../../Modals/EditItemModal';
import { useTranslation } from '../../../localization/useTranslation';
import _ from 'lodash';

const initalAssetState = {
  displayName: ''
};

const createAssetModels = [
  {
    type: ModelType.TEXT,
    label: Tl.common.parent,
    path: 'parent.name',
    placeholder: Tl.admin.assetInfo.parent.placeholder,
    disabled: true
  },
  {
    type: ModelType.TEXT,
    label: Tl.common.displayname,
    path: 'displayName',
    placeholder: Tl.admin.createAsset.name.placeholder,
    isRequired: true,
    hasError: _.isEmpty
  }
];


const NewAssetNode = ({ isOpen, onSave, onCancel, parent }) => {
  const [asset, setAsset] = useState({ parent: parent, ...initalAssetState });
  const T = useTranslation();

  useEffect(() => {
    setAsset({
      parent: parent,
      ...initalAssetState
    });
  }, [parent]);

  const models = createAssetModels;

  const _onSave = () => {
    // onSave({ id: uuidv4(), parent: parent, displayName: asset.name, name: asset.name, type: NodeType.Node, relationshipType: NodeRelationshipType.Contains, children: [] });
    onSave({ parentNodeId: parent.id, displayName: asset.displayName });
  };

  return (
    <>
      <EditItemModal
        isOpen={isOpen}
        // isLoading={isCreatingUser}
        title={T.admin.createAsset.title}
        onSave={_onSave}
        onCancel={onCancel}
        item={asset}
        setItem={setAsset}
        models={models}
      />
    </>
  );
};

export default NewAssetNode;
